import { render } from "./AppInformationCard.vue?vue&type=template&id=edfce4e2&scoped=true"
import script from "./AppInformationCard.vue?vue&type=script&lang=js"
export * from "./AppInformationCard.vue?vue&type=script&lang=js"

import "./AppInformationCard.vue?vue&type=style&index=0&id=edfce4e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-edfce4e2"

export default script